import { SELECT_ATTACHMENT, UNSELECT_ATTACHMENT } from './attachment.actions';
import { encode } from 'urlencode';
import { IAttachmentInstance } from './share.reducer';

export interface IAttachmentState {
  currentAttachmentId: string;
}

const attachmentInitialState: IAttachmentState = {
  currentAttachmentId: undefined
};

export function attachmentReducer(state = attachmentInitialState, action: any) {
  switch (action.type) {
    case SELECT_ATTACHMENT:
      if (state.currentAttachmentId === action.attachmentId) {
        return state;
      }
      return Object.assign({}, state, {
        currentAttachmentId: action.attachmentId
      });
    case UNSELECT_ATTACHMENT:
      return Object.assign({}, attachmentInitialState);
    default:
      return state;
  }
}
